import * as React from 'react';
import {
    Edit,
    NumberInput,
    SimpleForm,
    required,
    useTranslate,
    Toolbar,
    SaveButton,
} from 'react-admin';
import { Grid } from '@mui/material';

import FullNameField from './FullNameField';

const req = [required()];

const onRedirect = () => {
    return `settings/calculator/`;
};

const EditToolbar = () => (
    <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <SaveButton />
    </Toolbar>
);

const EntityEdit = () => {
    const translate = useTranslate();

    return (
        <Edit
            resource="settings/serializable"
            queryOptions={{
                meta: {
                    namespace: 'Logistics',
                    path: 'calculation_insurance_prices',
                },
            }}
            mutationOptions={{
                meta: {
                    namespace: 'Logistics',
                    path: 'calculation_insurance_prices',
                },
            }}
            title={<EditTitle />}
            mutationMode="pessimistic"
            redirect={onRedirect}
        >
            <SimpleForm toolbar={<EditToolbar />}>
                <div>
                    <Grid
                        container
                        width={{ xs: '100%', xl: '80%' }}
                        spacing={2}
                    >
                        <Grid item xs={12} md={10} xl={12}>
                            <NumberInput
                                source="limit"
                                label={translate(
                                    'resources.calculation_insurance_prices.fields.limit'
                                )}
                                fullWidth
                                isRequired
                                validate={req}
                            />
                            <NumberInput
                                source="price"
                                label={translate(
                                    'resources.calculation_insurance_prices.fields.price'
                                )}
                                fullWidth
                                isRequired
                                validate={req}
                            />
                        </Grid>
                    </Grid>
                </div>
            </SimpleForm>
        </Edit>
    );
};

// @ts-ignore
const EditTitle = () => <FullNameField size="32" sx={{ margin: '5px 0' }} />;

export default EntityEdit;
